import React from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import { Protection } from "@sportal/api";

import { getProfileProtection } from "../../../../store/profiles/profiles.selectors";
import { useIntlTranslate } from "../../../../hooks";
import { TabsSelect } from "../../../../components/tabsSelect/TabsSelect";
import { TabItem } from "../../../../components/tabList";
import { ProtectionLevel } from "./webFilters.types";
import {
  useChangeProtectionAction,
  useCategories,
  useProtectionLevels,
} from "./hooks";

import "./WebFiltersProtectionToolbar.scss";

const getProtectionItems = (
  protectionLevels: ProtectionLevel[],
  categoryNames: string[],
  customCategoryNames: string[],
  translate: (id: string, values?: {}) => string
): TabItem[] => {
  return protectionLevels.map((protection: ProtectionLevel) => {
    const protectionLabel = translate(
      `aria_protection_${protection.value}_label`,
      {
        blockedCount: protection.categories.filter((category) =>
          categoryNames.includes(category)
        ).length,
        totalCount: categoryNames.length,
      }
    );

    return {
      content: translate(protection.value),
      id: protection.value,
      config: {
        disabled:
          protection.value === Protection.Custom &&
          _.isEmpty(customCategoryNames),
        ariaLabel: protectionLabel,
      },
    };
  });
};

export interface WebFiltersProtectionToolbarProps {
  profileId: string;
}

export const WebFiltersProtectionToolbar = ({
  profileId,
}: WebFiltersProtectionToolbarProps) => {
  const translate = useIntlTranslate();
  const protectionLevels = useProtectionLevels(profileId);
  const { categoryNames, customCategoryNames } = useCategories(profileId);

  const items = getProtectionItems(
    protectionLevels,
    categoryNames,
    customCategoryNames,
    translate
  );

  const protection = useSelector(getProfileProtection(profileId));

  const changeProtection = useChangeProtectionAction(profileId);

  return (
    <div className="web-filters-protection-toolbar">
      <TabsSelect
        items={items}
        selected={protection}
        onClick={changeProtection}
        ariaStatus="aria_protection_level_status"
        ariaLabel={translate("aria_protection_level_list_label")}
      />
    </div>
  );
};
